//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.AlignmentMethodBuilder.js";
import "../GeometricUtilities/GeometricUtilities.Continuity.js";
import "../GeometricUtilities/GeometricUtilities.FlowDirection.js";
import "../GeometricUtilities/GeometricUtilities.Rebuild.js";
import "../no/Section.js";
import "../no/SectionList.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
import "../no/ObjectList.js";
let d=[[[1,"Alignment",0,"GeometricUtilities.AlignmentMethodBuilder",1],[0,"BodyPreference",1,1],[0,"ClosedInV",1,1],[0,"Construction",1,1],[0,"CurvatureTolerance",1,1],[1,"FirstSectionContinuity",0,"GeometricUtilities.Continuity",1],[1,"FlowDirection",0,"GeometricUtilities.FlowDirection",1],[1,"LastSectionContinuity",0,"GeometricUtilities.Continuity",1],[1,"LoftingSurfaceRebuildData",0,"GeometricUtilities.Rebuild",1],[0,"NormalToEndSections",1,1],[0,"PatchType",1,1],[0,"PositionTolerance",1,1],[0,"PreserveShape",1,1],[1,"SectionSurfaceRebuildData",0,"GeometricUtilities.Rebuild",1],[0,"SectionTemplateString",1,"Section",1],[1,"SectionsList",0,"SectionList",1],[0,"SplitOutputAlongBoundaryCurves",1,1],[0,"TangentTolerance",1,1]],[],[]];
SPLM.Features.ThroughCurvesBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ThroughCurvesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ThroughCurvesBuilder.PatchTypes = Object.freeze({
    "Single" : "Single", "Multiple" : "Multiple", "MatchString" : "MatchString"});

SPLM.Features.ThroughCurvesBuilder.ConstructionMethod = Object.freeze({
    "Normal" : "Normal", "SplinePoints" : "SplinePoints", "Simple" : "Simple"});

SPLM.Features.ThroughCurvesBuilder.BodyPreferenceTypes = Object.freeze({
    "Solid" : "Solid", "Sheet" : "Sheet"});

export default SPLM;